module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['container', ' profile']
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: ['col-12', 'mt-3', 'mb-3']
  }, [_c('div', {
    class: ['borderR5', 'my-1']
  }, [_c('Fleets')], 1)]), _vm._v(" "), _c('div', {
    class: ['col-xs-12 col-md-3 col-12']
  }, [_c('Vessels')], 1), _vm._v(" "), _c('div', {
    class: ['col-xs-12 col-md-9 col-12']
  }, [_c('VesselForm')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/PhpstormProjects/e-crewing/~/vue-loader/lib/template-compiler.js?id=data-v-758d579f!C:/PhpstormProjects/e-crewing/~/vue-loader/lib/selector.js?type=template&index=0!./vue/fleet/App.vue
// module id = 181
// module chunks = 3